var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","small":"","href":_vm.buyAlbumUrl,"target":"_blank","color":_vm.$config.colors.primary,"title":_vm.$lang.buyAlbumViaPayPal(_vm.album.title)}},[_vm._v(_vm._s(_vm.$lang.buyAlbum(_vm.$config.payPalAlbumPrice)))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4550b872","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy-album.vue
// module id = null
// module chunks = 